import { zhTW } from "date-fns/locale";
import { LocalizationProvider, LocalizationProviderProps } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

export default function MuiLocalization(props?: Partial<LocalizationProviderProps>) {
  return <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={zhTW} {...props} />;
}
